export const percent = (numerator, denominator, max=100) => {
  if (denominator === 0)
    return 0

  const val = numerator / denominator * 100
  return val <= max ? val : max
}
